define('core/Page',[
	'jQuery',
	'3rdparty/jquery.throttle-debounce',
	'3rdparty/jquery.inview',
], function ($, td, inview) {
	'use strict';

	var $window = $(window),
		$body = $('body'),
		allowedEventTypes = ['resize', 'scroll'],
		isResizingClass = 'is-resizing',
		isScrollingClass = 'is-scrolling',
		applyTransitionClass = 'apply-transitions',
		isFunction = $.isFunction,
		throttle = td.throttle,
		debounce = td.debounce,
		disableHoverTimer,
		disableHoverClass = 'disable-hover'
	;

	var startResizeFunctions = {},
		whileResizeFunctions = {},
		endResizeFunctions = {},
		startScrollFunctions = {},
		whileScrollFunctions = {},
		endScrollFunctions = {}
	;

	var initialScrollTop = $window.scrollTop(),
		initialScrollLeft = $window.scrollLeft(),

		startScrollTop = initialScrollTop,
		startScrollLeft = initialScrollLeft,
		scrollTop = initialScrollTop,
		scrollLeft = initialScrollLeft,
		endScrollTop = initialScrollTop,
		endScrollLeft = initialScrollLeft
	;

	var module = {
		onStartResize: function(id, func) {
			if (isFunction(func)) {
				startResizeFunctions[id] = func;
			}
			return this;
		},
		offStartResize: function(id) {
			startResizeFunctions[id] = undefined;
		},
		onWhileResize: function(id, func) {
			if (isFunction(func)) {
				whileResizeFunctions[id] = func;
			}
			return this;
		},
		offWhileResize: function(id) {
			whileResizeFunctions[id] = undefined;
		},
		onEndResize: function(id, func) {
			if (isFunction(func)) {
				endResizeFunctions[id] = func;
			}
			return this;
		},
		offEndResize: function(id) {
			endResizeFunctions[id] = undefined;
		},


		onStartScroll: function(id, func) {
			if (isFunction(func)) {
				startScrollFunctions[id] = func;
			}
			return this;
		},
		offStartScroll: function(id) {
			startScrollFunctions[id] = undefined;
		},

		onWhileScroll: function(id, func) {
			if (isFunction(func)) {
				whileScrollFunctions[id] = func;
			}
			return this;
		},
		offWhileScroll: function(id) {
			whileScrollFunctions[id] = undefined;
		},

		onEndScroll: function(id, func) {
			if (isFunction(func)) {
				endScrollFunctions[id] = func;
			}
			return this;
		},
		offEndScroll: function(id) {
			endScrollFunctions[id] = undefined;
		},

		trigger: function(eventType) {
			if (allowedEventTypes.indexOf(eventType) !== -1) {
				$window.trigger(eventType);
			}
			return this;
		},



		// getter
		startScrollTop: function() {
			return startScrollTop;
		},
		startScrollLeft: function() {
			return startScrollLeft;
		},
		scrollTop: function() {
			return scrollTop;
		},
		scrollLeft: function() {
			return scrollLeft;
		},
		endScrollTop: function() {
			return endScrollTop;
		},
		endScrollLeft: function() {
			return endScrollLeft;
		},

		width: function() {
			return inview.getViewportSize().width;
		},
		height: function() {
			return inview.getViewportSize().height;
		}
	};



	var startResize = debounce(50, true, function() {
		var that = this,
			args = arguments
		;

		$body.addClass(isResizingClass);
		$body.removeClass(applyTransitionClass);

		$.each(startResizeFunctions, function (idx, func) {
			if (isFunction(func)) {
				func.apply(that, args);
			}
		});
	});
	var whileResize = throttle(250, function() {
		var that = this,
			args = arguments
		;

		$.each(whileResizeFunctions, function (idx, func) {
			if (isFunction(func)) {
				func.apply(that, args);
			}
		});
	});
	var endResize = debounce(150, false, function() {
		var that = this,
			args = arguments
		;

		$body.removeClass(isResizingClass);
		$body.addClass(applyTransitionClass);

		$.each(endResizeFunctions, function (idx, func) {
			if (isFunction(func)) {
				func.apply(that, args);
			}
		});
	});


	var startScroll = debounce(50, true, function() {
		var that = this,
			args = arguments
		;

		startScrollTop = $window.scrollTop();
		startScrollLeft = $window.scrollLeft();

		$body.addClass(isScrollingClass);
		// $body.removeClass(applyTransitionClass);

		$.each(startScrollFunctions, function (idx, func) {
			if (isFunction(func)) {
				func.apply(that, args);
			}
		});
	});
	var whileScroll = throttle(100, function() {
		var that = this,
			args = arguments
		;

		scrollTop = $window.scrollTop();
		scrollLeft = $window.scrollLeft();

		$.each(whileScrollFunctions, function (idx, func) {
			if (isFunction(func)) {
				func.apply(that, args);
			}
		});
	});
	var endScroll = debounce(150, false, function() {
		var that = this,
			args = arguments
		;

		endScrollTop = $window.scrollTop();
		endScrollLeft = $window.scrollLeft();

		$body.removeClass(isScrollingClass);
		$body.addClass(applyTransitionClass);

		$.each(endScrollFunctions, function (idx, func) {
			if (isFunction(func)) {
				func.apply(that, args);
			}
		});
	});

	var disableHover = function() {
		// Disable hover while scrolling
		clearTimeout(disableHoverTimer);
		$body.addClass(disableHoverClass);

		disableHoverTimer = setTimeout(function() {
			$body.removeClass(disableHoverClass);
		}, 300);
	};

	$window.on('resize', function() {
		startResize();
		whileResize();
		endResize();

		//disableHover();
	});

	$window.on('scroll', function() {
		startScroll();
		whileScroll();
		endScroll();

		//disableHover();
	});

	return module;
});

